import React, { useState } from 'react';
import { add, isBefore, format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import './Tile.scss';
import { RootState } from '../../../configs/store';
import { getFlag } from '../../../utils/utils';
// import logo2 from '../../../assets/images/betxchange-logo2.png';
import Icon from '../../../components/Icon/Icon';
import CountDown from '../../../components/CountDown/CountDown';
import Button from '../../../components/Button/Button';

interface TileProps {
  event: {
    numbersRules:
      {
        imageMobile: string,
        imageDesktop: string,
      },
    description: string
    countryCode: string,
    name: string,
    eventStart: number,
    code: number,
    eventId: number,
    cardCode: number,
    couponCode: number
  },
  showCodes: boolean
}

function Tile({ event, showCodes }: TileProps)  {
  const [description, setDescription] = useState<boolean>(false);
  const { t } = useTranslation('common');
  const location = useLocation();
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);
  const eventStart = event.eventStart * 1000;
  const date = utcToZonedTime(eventStart, selectedTimezone);
  const formattedDate = format(date, 'EEE, MMM dd, HH:mm');
  const hasCountdown = isBefore(eventStart, add(new Date(), { hours: 1 }));

  const toggleDescription = () => {
    setDescription(!description);
  };

  let enventName = event.name && (event.name).includes('-') ? event.name.split('-') : [event.name, ''];

  if (!event.name){
    enventName = ['', ''];
  }

  return (
    <div
      className={
        classNames({
          'tile__tile number-bet__tile--normal': true,
          'tile__tile--no-countdown': !hasCountdown
        })
      }
    >
      <div className="tile__top">
        {
          description && <div className="tile__info">
            <Icon
              className="tile__close"
              icon="close"
              onClick={ toggleDescription }
            />
            <div className="tile__info--top">
              <span className="tile__name">{ `${ event.name } - ${ event.cardCode }/${ event.couponCode }` }:</span>
              {
                hasCountdown && (
                  <span className="tile__countdown tile__countdown--small">
                    <CountDown timeTillDate={ eventStart } type="small" />
                  </span>
                )
              }
            </div>
            <div className="tile__date--info">{ formattedDate }</div>
            <div className="tile__description">
              { event?.description }
            </div>
          </div>
        }
        <div
          className="tile__flag tile__flag--small"
          style={ { backgroundImage: `url(${ getFlag(event.countryCode) })` } }
        ></div>
        <div>
          <h2 className="tile__subtitle">{
            enventName[0]
          }</h2>
          <h2 className="tile__subtitle">{
            showCodes &&  event.cardCode ?
              `${ enventName[1] } - ${ event.cardCode }/${ event.couponCode }` :
              enventName[1]
          }</h2>
        </div>
        <Icon
          className={
            classNames({
              'tile__icon': true,
              'tile__icon--open': description
            })
          }
          icon={ description ? 'filledI' : 'info' }
          onClick={ toggleDescription }
        />
      </div>
      <div className="tile__container">
        <picture>
          <source
            className="tile__image"
            srcSet={ event.numbersRules?.imageDesktop ? event.numbersRules.imageDesktop : 'logo2' }
            media="(max-width: 1366px)"
          />
          <img
            className="tile__image"
            src={ event.numbersRules?.imageDesktop ? event.numbersRules.imageDesktop : 'logo2' }
            alt={ `${ event.name } - ${ event.cardCode }/${ event.couponCode }` }
          />
        </picture>
        <div className="tile__bottom">
          {
            hasCountdown && <div className="tile__divider">
              <div
                className={
                  classNames({
                    'tile__countdown': true,
                    'tile__countdown--open': description
                  })
                }
              >
                <div className="tile__date tile__date--countdown">{ formattedDate }</div>
                <CountDown timeTillDate={ eventStart } />
              </div>
            </div>
          }
          {
            !hasCountdown && (<div
              className={
                classNames({
                  'tile__date number-bet__date--mobile': true,
                  'tile__date--open': description
                })
              }
            >
              { formattedDate }
            </div>)
          }
          <div className="tile__divider">
            <Button
              className="btn--primary tile__button"
              size="medium"
              text={ t('numbers.playNow') }
              link= { `/lotto/${ event.code }/${ event.eventId }${ location.search }` }
            />
          </div>
        </div>
      </div>
    </div>
  );

}

export default Tile;
